import { render, staticRenderFns } from "./INRIcon.vue?vue&type=template&id=2dbc6470&scoped=true&"
import script from "./INRIcon.vue?vue&type=script&lang=js&"
export * from "./INRIcon.vue?vue&type=script&lang=js&"
import style0 from "./INRIcon.vue?vue&type=style&index=0&id=2dbc6470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc6470",
  null
  
)

export default component.exports